import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Offcanvas, Form } from 'react-bootstrap';
import { MdArrowBack } from "react-icons/md";
import * as apicall from '../../components/Apicall';
import Skeleton from '../../components/Loader/Skeleton';
import { toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

import { Formik } from 'formik';
import * as Yup from 'yup';


const ViewProfile = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showEditSidebar, setShowEditSidebar] = useState(false);
  const [fallbackColor, setFallbackColor] = useState('');

  const getRandomColor = () => {
    const colors = [
      '#FFE4E1', // Misty Rose
      '#E6E6FA', // Lavender
      '#F0FFF0', // Honeydew
      '#F0F8FF', // Alice Blue
      '#FFF0F5', // Lavender Blush
      '#F5F5DC', // Beige
      '#E0FFFF', // Light Cyan
      '#FFE4B5', // Moccasin
      '#F0FFFF', // Azure
      '#F8F8FF'  // Ghost White
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  const getInitials = (name) => {
    if (!name) return '';
    const nameParts = name.split(' ').filter(part => part.length > 0);
    if (nameParts.length === 0) return '';
    if (nameParts.length === 1) return nameParts[0][0].toUpperCase();
    return (nameParts[0][0] + nameParts[nameParts.length - 1][0]).toUpperCase();
  };




  useEffect(() => {
    const fetchUserData = async () => {
      try {
        setLoading(true);
        const response = await apicall.get('myProfile');
        const profile = response.data[0];
        const transformedData = {
          personalDetails: {
            fullName: `${profile.first_name}`.trim(),
            gender: profile.gender === 1 ? 'Male' : 'Female',
            totalExperience: profile.practice_start ? calculateExperience(profile.practice_start) : ''
          },
          addressDetails: {
            address: profile.address || '',
            city: profile.city_name || '',
            state: profile.state_name || '',
            country: profile.country_name || ''
          },
          contactDetails: {
            phoneNumber: profile.phone_number || '',
            email: profile.email || ''
          },
          profileImage: profile.profile_image || ''
        };
  
        setUserData(transformedData);
        setFallbackColor(getRandomColor());
        setError(null);
      } catch (err) {
        console.error('Error fetching profile data:', err);
        setError('Failed to load profile data. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
  
    fetchUserData();
  }, []);
  
  const handleBack = () => {
    navigate(-1);
  };

  const handleEditProfile = () => {
    setShowEditSidebar(true);
  };

  const calculateExperience = (practiceStart) => {
    if (!practiceStart) return '0';
    const startDate = new Date(practiceStart);
    const currentDate = new Date();
    const years = currentDate.getFullYear() - startDate.getFullYear();
    return `${years} Years Experience`;
  };

  

  const EditProfileSidebar = () => {
      const [formData, setFormData] = useState({
    first_name: userData?.personalDetails.fullName.split(' ')[0] || '',
    gender: userData?.personalDetails.gender === 'Male' ? 1 : 2,
    address: userData?.addressDetails.address || '',
    city_id: '',
    state_id: '',
    country_id: '',
    phone_number: userData?.contactDetails.phoneNumber || '',
    email: userData?.contactDetails.email || ''
  });

    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const profileSchema = Yup.object().shape({
    first_name: Yup.string().required('Full name is required'),
    gender: Yup.number().oneOf([1, 2], 'Gender is required'),
    country_id: Yup.string().required('Country is required'),
    state_id: Yup.string().required('State is required'),
    // city_id: Yup.string().when([], function (_, context) {
    //   const cities = context && context.cities;
    //   if (cities && cities.length > 0) {
    //     return Yup.string().required('City is required');
    //   }
    //   return Yup.string();
    // }),
    email: Yup.string().email('Invalid email').required('Email is required'),
  });

    const fetchCountries = async () => {
      try {
        const response = await apicall.get('country');
       
        if (response?.data) {
          // Handle both array and object responses
          const countriesData = Array.isArray(response.data) ? response.data : [response.data];
          setCountries(countriesData);
          return countriesData;
        }
        return [];
      } catch (error) {
        console.error('Error fetching countries:', error);
        return [];
      }
    };

    const fetchStates = async (countryId) => {
      if (!countryId) {
      
        return [];
      }
      try {
        const response = await apicall.get(`state/${countryId}`);
        if (response?.data) {
          const statesData = Array.isArray(response.data) ? response.data : [response.data];
          setStates(statesData);
          return statesData;
        }
        setStates([]);
        return [];
      } catch (error) {
        console.error('Error fetching states:', error);
        setStates([]);
        return [];
      }
    };

    const fetchCities = async (stateId) => {
      if (!stateId) {
        return [];
      }
      try {
        const response = await apicall.get(`city/${stateId}`);
        if (response?.data) {
          const citiesData = Array.isArray(response.data) ? response.data : [response.data];
          setCities(citiesData);
          return citiesData;
        }
        setCities([]);
        return [];
      } catch (error) {
        console.error('Error fetching cities:', error);
        setCities([]);
        return [];
      }
    };

    // Initial data load
    useEffect(() => {
      const initializeData = async () => {
        try {
          setIsLoading(true);
          // Fetch countries first
          const countriesData = await fetchCountries();
          if (countriesData.length > 0) {
            // Find country by name first
            const currentCountry = countriesData.find(
              c => {
                const countryName = c.country_name || c.name;
                const searchName = userData?.addressDetails?.country;
                return countryName?.toLowerCase() === searchName?.toLowerCase();
              }
            );
           
            if (currentCountry) {
              const countryId = currentCountry.id || currentCountry.country_id;
              setFormData(prev => ({ ...prev, country_id: countryId }));
              // Fetch states for the selected country
              const statesData = await fetchStates(countryId);
              if (statesData.length > 0) {
                // Log the current state name we're looking for
                // Find state by name
                const currentState = statesData.find(
                  s => {
                    const stateName = s.state_name || s.name;
                    const searchName = userData?.addressDetails?.state;
                    return stateName?.toLowerCase() === searchName?.toLowerCase();
                  }
                );
                if (currentState) {
                  const stateId = currentState.id || currentState.state_id;
                  setFormData(prev => ({ ...prev, state_id: stateId }));
                  // Fetch cities for the selected state
                  const citiesData = await fetchCities(stateId);
                  if (citiesData.length > 0) {
                    // Find city by name
                    const currentCity = citiesData.find(
                      c => {
                        const cityName = c.city_name || c.name;
                        const searchName = userData?.addressDetails?.city;
                        return cityName?.toLowerCase() === searchName?.toLowerCase();
                      }
                    );
                    if (currentCity) {
                      const cityId = currentCity.id || currentCity.city_id;
                      setFormData(prev => ({ ...prev, city_id: cityId }));
                    }
                  }
                }
              }
            }
          }
        } catch (error) {
          console.error('Error initializing data:', error);
        } finally {
          setIsLoading(false);
        }
      };
      if (userData) {
        initializeData();
      }
    }, [userData]);

    const handleInputChange = async (e) => {
      const { name, value } = e.target;
      
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));

      // Handle cascading updates
      if (name === 'country_id') {
        if (value) {
          await fetchStates(value);
          // Reset state and city when country changes
          setFormData(prev => ({ 
            ...prev, 
            state_id: '',
            city_id: ''
          }));
          setCities([]);
        } else {
          setStates([]);
          setCities([]);
          setFormData(prev => ({ ...prev, state_id: '', city_id: "" }));
        }
      } else if (name === 'state_id') {
        if (value) {
          await fetchCities(value);
          // Reset city when state changes
          setFormData(prev => ({ 
            ...prev, 
            city_id: ""
          }));
        } else {
          setCities([]);
          setFormData(prev => ({ ...prev, city_id: "" }));
        }
      }
    };

    const handleSubmit = async (values) => {
  // Prepare the payload
  const payload = {
    first_name: values.first_name,
    gender: values.gender,
    address: values.address,
    country_id: values.country_id,
    state_id: values.state_id,
    city_id: cities && cities.length > 0 ? values.city_id : null,
    phone_number: values.phone_number
  };

  // Only include email if it's changed
  if (values.email !== userData.contactDetails.email) {
    payload.email = values.email;
  }

  try {
    const response = await apicall.post(payload, 'updateUser');
    if (response.status === 200) {
      toast.success('Profile updated successfully', { autoClose: 1500 });
      setShowEditSidebar(false);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    }
  } catch (error) {
    console.error('Error updating profile:', error);
    console.error('Error details:', error.response?.data);
    toast.error('Failed to update profile. Please try again.');
  }
};

    const SidebarSkeleton = () => {
      return (
        <div className="p-4">
          <div className="mb-4">
            <Skeleton width="120px" height="24px" marginBottom="16px" />
            {[...Array(5)].map((_, index) => (
              <div key={index} className="mb-3">
                <Skeleton width="100px" height="20px" marginBottom="8px" />
                <Skeleton width="100%" height="38px" />
              </div>
            ))}
          </div>

          <div className="mb-4">
            <Skeleton width="120px" height="24px" marginBottom="16px" />
            {[...Array(4)].map((_, index) => (
              <div key={index} className="mb-3">
                <Skeleton width="100px" height="20px" marginBottom="8px" />
                <Skeleton width="100%" height="38px" />
              </div>
            ))}
          </div>

          <div className="mb-4">
            <Skeleton width="120px" height="24px" marginBottom="16px" />
            {[...Array(2)].map((_, index) => (
              <div key={index} className="mb-3">
                <Skeleton width="100px" height="20px" marginBottom="8px" />
                <Skeleton width="100%" height="38px" />
              </div>
            ))}
          </div>
        </div>
      );
    };

    return (
      <Offcanvas 
        show={showEditSidebar} 
        onHide={() => setShowEditSidebar(false)} 
        placement="end"
        style={{ width: '500px' }}
        
      >
        <Offcanvas.Header closeButton className="custom-border-bottom p-4">
        <Offcanvas.Title className="page-heading">Edit Profile</Offcanvas.Title>
          
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {isLoading ? (
            <SidebarSkeleton />
          ) : (
            <div className="p-4">
              <Formik
                initialValues={formData}
                validationSchema={profileSchema}
                onSubmit={handleSubmit}
                enableReinitialize
                validationContext={{ cities }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <div className="mb-4">
                      <h6 className="profile-section-heading">Personal Details</h6>
                      <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control 
                          type="text" 
                          name="first_name"
                          value={values.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.first_name && errors.first_name}
                          className="form-input"
                        />
                        {touched.first_name && errors.first_name && (
                          <div className="invalid-feedback d-block">{errors.first_name}</div>
                        )}
                      </Form.Group>
                     
                     
                      <Form.Group className="mb-3">
                        <Form.Label >Gender</Form.Label>
                        <Form.Select 
                          name="gender"
                          value={values.gender}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.gender && errors.gender}
                          className="form-input"
                        >
                          <option value={1}>Male</option>
                          <option value={2}>Female</option>
                        </Form.Select>
                        {touched.gender && errors.gender && (
                          <div className="invalid-feedback d-block">{errors.gender}</div>
                        )}
                      </Form.Group>



                      </div>

                      <div className="mb-4">
                      
                      <Form.Group className="mb-3">
                        <Form.Label>Country</Form.Label>
                        <Form.Select 
                          name="country_id"
                          value={values.country_id}
                          onChange={async (e) => {
                            const countryId = e.target.value;
                            setFieldValue('country_id', countryId);
                            if (countryId) {
                              await fetchStates(countryId);
                              setFieldValue('state_id', '');
                              setFieldValue('city_id', '');
                              setCities([]);
                            } else {
                              setStates([]);
                              setCities([]);
                              setFieldValue('state_id', '');
                              setFieldValue('city_id', "");
                            }
                          }}
                          isInvalid={touched.country_id && errors.country_id}
                          className="form-input label-bgcolor"
                          disabled
                        >
                          <option value="">Select Country</option>
                          {countries.map(country => (
                            <option key={country.id} value={country.id}>
                              {country.name || country.country_name}
                            </option>
                          ))}
                        </Form.Select>
                        {touched.country_id && errors.country_id && (
                          <div className="invalid-feedback d-block">{errors.country_id}</div>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label >State</Form.Label>
                        <Form.Select 
                          name="state_id"
                          value={values.state_id}
                          onChange={async (e) => {
                            const stateId = e.target.value;
                            setFieldValue('state_id', stateId);
                            if (stateId) {
                              const fetchedCities = await fetchCities(stateId);
                              if (!fetchedCities || fetchedCities.length === 0) {
                                setFieldValue('city_id', null);
                              } else {
                                setFieldValue('city_id', '');
                              }
                            } else {
                              setCities([]);
                              setFieldValue('city_id', null);
                            }
                          }}
                          isInvalid={touched.state_id && errors.state_id}
                          className="form-input label-bgcolor"
                          disabled
                        >
                          <option value="">Select State</option>
                          {states.map(state => (
                            <option key={state.id} value={state.id}>
                              {state.name}
                            </option>
                          ))}
                        </Form.Select>
                        {touched.state_id && errors.state_id && (
                          <div className="invalid-feedback d-block">{errors.state_id}</div>
                        )}
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label >City</Form.Label>
                        <Form.Select 
                          name="city_id"
                          value={values.city_id}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.city_id && errors.city_id}
                          className="form-input label-bgcolor"
                          disabled
                        >
                          <option value="">Select City</option>
                          {cities.map(city => (
                            <option key={city.id} value={city.id}>
                              {city.name}
                            </option>
                          ))}
                        </Form.Select>
                        {touched.city_id && errors.city_id && (
                          <div className="invalid-feedback d-block">{errors.city_id}</div>
                        )}
                      </Form.Group>
                    </div>

                    <div className="mb-4">
                      <h6 className="profile-section-heading">Contact Details</h6>
                      <Form.Group className="mb-3">
                        <Form.Label>Phone Number</Form.Label>
                        <PhoneInput
                          country={'ae'}
                          onlyCountries={['ae', 'in']}
                          value={values.phone_number}
                          onChange={(value) => {
                            const cleanedValue = value.replace(/\D/g, '');
                            setFieldValue('phone_number', cleanedValue);
                          }}
                          inputStyle={{
                            width: '100%',
                            height: '40px',
                            backgroundColor: '#F8F9FA',
                            borderColor: '#E9ECEF'
                          }}
                          inputProps={{
                            name: 'phone_number',
                            required: true,
                            // disabled: true
                          }}
                          disabled
                        />
                      </Form.Group>
                      <Form.Group className="mb-3">
                        <Form.Label >Email</Form.Label>
                        <Form.Control 
                          type="email" 
                          name="email"
                          value={values.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          isInvalid={touched.email && errors.email}
                          className="form-input"
                        />
                        {touched.email && errors.email && (
                          <div className="invalid-feedback d-block">{errors.email}</div>
                        )}
                      </Form.Group>
                    </div>
                    <div className="position-sticky bottom-0 bg-white custom-border-top p-4 d-flex gap-3">
                      <Button 
                        variant="light" 
                        onClick={() => setShowEditSidebar(false)}
                          className="custom-radius btn-outline-borders"
                          type="button"
                          style={{ flex: 1 }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="danger"
                          className="btn-custom-danger custom-radius"
                          type="submit"
                          style={{ flex: 1 }}
                      >
                        Save Changes
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    );
  };

  const ProfileSkeleton = () => {
    return (
      <div className="px-4 py-3">
        <div className="d-flex align-items-center mb-4">
          <Skeleton width="80px" height="24px" />
        </div>

        <div className="bg-white border-box p-4 rounded-4">
          <div className="d-flex gap-5">
            {/* Left Column - Profile Image Skeleton */}
            <div className="d-flex flex-column align-items-center" style={{ width: '258px' }}>
              <Skeleton width="258px" height="248px" marginBottom="16px" />
              <Skeleton width="121px" height="32px" />
            </div>

            {/* Right Column - Details Skeleton */}
            <div className="flex-grow-1">
              <div className="row g-4">
                {/* Personal Details Skeleton */}
                <div className="col-md-4">
                  <Skeleton width="120px" height="24px" marginBottom="16px" />
                  <div className="d-flex flex-column gap-3">
                    {[...Array(4)].map((_, index) => (
                      <div key={index}>
                        <Skeleton width="80px" height="16px" marginBottom="8px" />
                        <Skeleton width="140px" height="20px" />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Address Details Skeleton */}
                <div className="col-md-4">
                  <Skeleton width="120px" height="24px" marginBottom="16px" />
                  <div className="d-flex flex-column gap-3">
                    {[...Array(4)].map((_, index) => (
                      <div key={index}>
                        <Skeleton width="80px" height="16px" marginBottom="8px" />
                        <Skeleton width="140px" height="20px" />
                      </div>
                    ))}
                  </div>
                </div>

                {/* Contact Details Skeleton */}
                <div className="col-md-4">
                  <Skeleton width="120px" height="24px" marginBottom="16px" />
                  <div className="d-flex flex-column gap-3">
                    {[...Array(2)].map((_, index) => (
                      <div key={index}>
                        <Skeleton width="80px" height="16px" marginBottom="8px" />
                        <Skeleton width="140px" height="20px" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  if (loading) {
    return <ProfileSkeleton />;
  }

  if (error) {
    return <div className="p-4 text-danger">{error}</div>;
  }

  if (!userData) {
    return <div className="p-4">No profile data available</div>;
  }

  return (
    <div className="px-4 py-3">
      <div className="d-flex align-items-center mb-4">
        <Button
          variant="link"
          className="back-button text-dark text-decoration-none p-0"
          onClick={handleBack}
        >
           <MdArrowBack size={20} /> BACK
        </Button>
      </div>

      <div className="bg-white border-box p-4 rounded-4">
        <div className="d-flex flex-column flex-lg-row gap-4">
          {/* Left Column - Profile Image */}
          <div className="d-flex flex-column align-items-center" style={{ 
            width: '100%', 
            maxWidth: '258px', 
            margin: '0 auto',
            aspectRatio: '1/1',
            minWidth: '200px'
          }}>
            <div className="position-relative w-100" style={{ 
              paddingBottom: '100%', // Creates a 1:1 aspect ratio
              height: '0',
              minHeight: '200px',
              maxHeight: '258px'
            }}>
              {userData.profileImage ? (
                <img
                  src={userData.profileImage}
                  alt={userData.personalDetails.fullName}
                  className="border-box profile-image-shadow w-100 h-100"
                  style={{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    borderRadius: '20px',
                    objectFit: 'cover',
                    minHeight: '200px',
                    maxHeight: '258px'
                  }}
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.nextElementSibling.style.display = 'flex';
                  }}
                />
              ) : null}
              <div
                className="border-box profile-image-shadow d-flex align-items-center justify-content-center w-100 h-100"
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  borderRadius: '20px',
                  backgroundColor: fallbackColor,
                  display: userData.profileImage ? 'none' : 'flex',
                  fontSize: 'calc(32px + 2vw)',
                  fontWeight: '500',
                  color: '#666666',
                  minHeight: '200px',
                  maxHeight: '258px'
                }}
              >
                {getInitials(userData.personalDetails.fullName)}
              </div>
            </div>
            <div className="d-flex justify-content-center gap-3 mt-3 mb-3 w-100">
              <Button
                variant="danger"
                onClick={handleEditProfile}
                className="btn-custom-danger custom-radius d-flex align-items-center justify-content-center"
                style={{
                  width: '121px',
                  height: '32px',
                  padding: '10px 16px',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                Edit Profile
              </Button>
            </div>
          </div>

          {/* Right Column - Details */}
          <div className="flex-grow-1">
            <div className="row g-4">
              {/* Personal Details */}
              <div className="col-12 col-md-6 col-lg-4">
                <h6 className="profile-section-heading">Personal Details</h6>
                <div className="d-flex flex-column gap-3">
                  <div>
                    <div className="label mb-1">Full Name</div>
                    <div className="content fw-bold text-dark text-break" style={{ 
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      maxWidth: '100%'
                    }}>{userData.personalDetails.fullName}</div>
                  </div>
                  <div>
                    <div className="label mb-1">Gender</div>
                    <div className="content fw-bold text-dark text-break">{userData.personalDetails.gender}</div>
                  </div>

                  <div>
                  </div>
                </div>
              </div>

              {/* Address Details */}
              <div className="col-12 col-md-6 col-lg-4">
                <h6 className="profile-section-heading">Address Details</h6>
                <div className="d-flex flex-column gap-3">
                  {/* <div>
                    <div className="label mb-1">Address Line</div>
                    <div className="content fw-bold text-dark text-break" style={{ 
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      maxWidth: '100%'
                    }}>{userData.addressDetails.address}</div>
                  </div> */}
                  <div>
                    <div className="label mb-1">City</div>
                    <div className="content fw-bold text-dark text-break">{userData.addressDetails.city}</div>
                  </div>
                  <div>
                    <div className="label mb-1">State</div>
                    <div className="content fw-bold text-dark text-break">{userData.addressDetails.state}</div>
                  </div>
                  <div>
                    <div className="label mb-1">Country</div>
                    <div className="content fw-bold text-dark text-break">{userData.addressDetails.country}</div>
                  </div>
                </div>
              </div>

              {/* Contact Details */}
              <div className="col-12 col-md-6 col-lg-4">
                <h6 className="profile-section-heading">Contact Details</h6>
                <div className="d-flex flex-column gap-3">
                  <div>
                    <div className="label mb-1">Phone Number</div>
                    <div className="content fw-bold text-dark text-break">{userData.contactDetails.phoneNumber}</div>
                  </div>
                  <div>
                    <div className="label mb-1">Email</div>
                    <div className="content fw-bold text-dark text-break" style={{ 
                      wordWrap: 'break-word',
                      overflowWrap: 'break-word',
                      maxWidth: '100%'
                    }}>{userData.contactDetails.email}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <EditProfileSidebar />
    </div>
  );
};

export default ViewProfile;